import styled from "styled-components";
import { Input } from "../../../../components/Input/input";
import { theme } from "../../../../helpers/theme";
import Icon from "../../../../components/icon";
import { ReactComponent as Info } from "../../../../assets/icons/info.svg";
import { ReactComponent as CheckedRounded } from "../../../../assets/icons/check.svg";
import {
  ClientData,
  VerificationEnum,
} from "../../../../services/users/get-logged/types";

interface ClientDataSectionProps {
  clientData: ClientData;
}
const ClientDataSection = ({ clientData }: ClientDataSectionProps) => {
  return (
    <ClientDataSectionContainer>
      <ClientDataHeader>Dane Klienta</ClientDataHeader>

      {clientData.weryfikacja === VerificationEnum.unverified && (
        <VerifyInfosWrapper>
          <Icon
            icon={
              <Info style={{ padding: 0, width: "30px", height: "30px" }} />
            }
          />
          <VerifyInfo>Twoje konto nie jest zweryfikowane</VerifyInfo>
        </VerifyInfosWrapper>
      )}

      {clientData.weryfikacja === VerificationEnum.positiveVerification && (
        <VerifyInfosWrapper>
          <Icon
            icon={
              <CheckedRounded
                style={{ padding: 0, width: "26px", height: "26px" }}
              />
            }
          />
          <VerifyInfo>Konto zweryfikowane pomyślnie</VerifyInfo>
        </VerifyInfosWrapper>
      )}

      {clientData.weryfikacja === VerificationEnum.negativeVerification && (
        <VerifyInfosWrapper>
          <Icon
            icon={
              <Info style={{ padding: 0, width: "30px", height: "30px" }} />
            }
          />
          <VerifyInfo>Twoje konto nie jest zweryfikowane</VerifyInfo>
        </VerifyInfosWrapper>
      )}

      <Input
        label="Nazwa"
        id="customerName"
        name="customerName"
        value={clientData.nazwa}
        disabled
        variant="outlined"
        sx={{
          width: "100%",
        }}
      />
      <Input
        label="NIP"
        id="companyNip"
        name="companyNip"
        value={clientData.nip}
        disabled
        variant="outlined"
        sx={{
          width: "100%",
        }}
      />
      <Input
        label="Telefon"
        id="customerPhone"
        name="customerPhone"
        type="phone"
        value={clientData.telefon}
        disabled
        variant="outlined"
        sx={{
          width: "100%",
        }}
      />
      <Input
        label="E-mail"
        id="customerEmail"
        name="customerEmail"
        value={clientData.email}
        disabled
        variant="outlined"
        sx={{
          width: "100%",
        }}
      />
    </ClientDataSectionContainer>
  );
};

export default ClientDataSection;

const ClientDataSectionContainer = styled.section`
  width: 300px;
  @media (max-width: 430px) {
    width: 270px;
  }
  max-height: 404px;
  border-radius: 16px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background-color: white;
`;
const VerifyInfosWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 14px;
  align-items: center;
`;
const ClientDataHeader = styled.span`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  width: 100%;
`;
const VerifyInfo = styled.span`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  width: 100%;
`;
